import { useCallback, useSyncExternalStore } from 'react';

export const DESKTOP_BREAKPOINT_PX = 768;

export function useIsDesktop(breakpoint = DESKTOP_BREAKPOINT_PX): boolean {
  const query = `(min-width: ${breakpoint}px)`;

  const subscribe = useCallback(
    (callback: () => void) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', callback);
      return () => mql.removeEventListener('change', callback);
    },
    [query]
  );

  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);

  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
